// Function to toggle body class for each nav toggle
function toggleNavClass( querySelector ) {
	document.querySelectorAll( querySelector ).forEach( ( node ) => {
		node.addEventListener( 'click', () => {
			if ( document.body.classList.contains( 'has-nav-open' ) ) {
				document.body.classList.remove( 'has-nav-open' );
			} else {
				document.body.classList.add( 'has-nav-open' );
			}
			if ( node.ariaExpanded === 'true' ) {
				node.ariaExpanded = 'false';
			} else {
				node.ariaExpanded = 'true';
			}
		} );
	} );
}

// Call toggleNavClass for elements with specific class
toggleNavClass( '.navigation-toggle .navigation-toggle__btn' );
